import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function NotFound() {
  useEffect(() => {
    document.title = "Page not found (404) | ProfitMigo";
    const m = document.head.querySelector('meta[name="robots"]') || document.createElement("meta");
    m.setAttribute("name", "robots");
    m.setAttribute("content", "noindex, follow");
    document.head.appendChild(m);
  }, []);

  return (
    <div className="mx-auto flex max-w-3xl flex-col items-start px-4 py-24 sm:px-6" data-testid="not-found">
      <span className="font-mono text-sm font-semibold text-primary">404</span>
      <h1 className="mt-2 font-display text-4xl font-bold tracking-tight sm:text-5xl">Page not found</h1>
      <p className="mt-4 text-lg text-muted-foreground">
        The page you're looking for doesn't exist or may have moved. Try one of our calculators instead.
      </p>
      <div className="mt-8 flex gap-3">
        <Button asChild><Link to="/">Back to home</Link></Button>
        <Button asChild variant="outline"><Link to="/calculators">Browse calculators</Link></Button>
      </div>
    </div>
  );
}
